import React from 'react';
import Box from '@mui/material/Box';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';

import {
  COLORS,
  COLORS_NEXT_DAY_PROMO,
  ORDER_TYPE_CLOUD_KITCHEN,
  ORDER_TYPE_NEXT_DAY_PROMOTION,
  ORDER_TYPE_RESTAURANT,
} from './orderManagementConfig';

const getActiveToggleStyle = (optValue) => {
  if (optValue === ORDER_TYPE_NEXT_DAY_PROMOTION) {
    return {
      bgcolor: COLORS_NEXT_DAY_PROMO.tabBadgeBg,
      color: COLORS_NEXT_DAY_PROMO.tabBadgeText,
      hoverInactive: { bgcolor: COLORS_NEXT_DAY_PROMO.orderBadgeBg, color: COLORS_NEXT_DAY_PROMO.ink },
    };
  }
  return {
    bgcolor: COLORS.ink,
    color: COLORS.white,
    hoverInactive: { bgcolor: '#F3F4F6', color: COLORS.ink },
  };
};

const VIEW_OPTIONS = [
  { value: ORDER_TYPE_RESTAURANT, label: 'Restaurant', Icon: StorefrontOutlinedIcon },
  { value: ORDER_TYPE_NEXT_DAY_PROMOTION, label: 'Next day Promotion', Icon: EventAvailableOutlinedIcon },
  { value: ORDER_TYPE_CLOUD_KITCHEN, label: 'Cloud Kitchen', Icon: CloudOutlinedIcon },
];

export function OrderManagementTypeToggle({ value, onChange, onViewMap, colors = COLORS }) {
  return (
    <Box
      sx={{
        maxWidth: 1320,
        mx: 'auto',
        mb: 2.5,
        px: { xs: 2, sm: 0 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          flexWrap: 'wrap',
          bgcolor: colors.white,
          border: `1.5px solid ${colors.border}`,
          borderRadius: '14px',
          p: '5px',
          boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
          gap: '4px',
        }}
      >
        {VIEW_OPTIONS.map(({ value: optValue, label, Icon }) => {
          const active = value === optValue;
          const activeStyle = getActiveToggleStyle(optValue);
          return (
            <Box
              key={optValue}
              onClick={() => onChange(optValue)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 2.5,
                py: 1.1,
                borderRadius: '10px',
                cursor: 'pointer',
                bgcolor: active ? activeStyle.bgcolor : 'transparent',
                color: active ? activeStyle.color : colors.muted,
                fontFamily: active ? 'Inter Bold, sans-serif' : 'Inter Regular, sans-serif',
                fontWeight: active ? 700 : 400,
                fontSize: 14,
                userSelect: 'none',
                transition: 'all 0.18s ease',
                whiteSpace: 'nowrap',
                '&:hover': active ? {} : activeStyle.hoverInactive,
              }}
            >
              <Icon sx={{ fontSize: 18 }} />
              {label}
            </Box>
          );
        })}
      </Box>

      {onViewMap && (
        <Box
          onClick={onViewMap}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            px: 2.5,
            py: 1.1,
            borderRadius: '14px',
            cursor: 'pointer',
            bgcolor: colors.white,
            color: colors.muted,
            border: `1.5px solid ${colors.border}`,
            boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
            fontFamily: 'Inter Regular, sans-serif',
            fontWeight: 400,
            fontSize: 14,
            userSelect: 'none',
            transition: 'all 0.18s ease',
            whiteSpace: 'nowrap',
            flexShrink: 0,
            '&:hover': {
              bgcolor: colors.headerBg,
              color: colors.ink,
              '& .MuiSvgIcon-root': { color: colors.ink },
            },
          }}
        >
          <MapOutlinedIcon sx={{ fontSize: 18, color: 'inherit', transition: 'color 0.18s ease' }} />
          View order on map
        </Box>
      )}
    </Box>
  );
}
